import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Small delay to allow exit animation to start
    // Then scroll before new page animates in
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50); // Delay just enough for exit to begin

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
